// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.register_imageArea__Y0PNs {
    float: left;
    position: fixed;
    height: 100vh;
    background: url(https://source.unsplash.com/random/1920x1080/?finance);
    width: 35%;
}
.register_imageArea__Y0PNs .register_imageAreaOverlay__zpJFT {
    background: rgb(0,0,0);
background: linear-gradient(180deg, rgba(0,0,0,0.5) 0%, rgba(0,0,0,0.5) 100%);
width: 100%;
height: 100%;
}
.register_contentArea__D2BtU {
    margin-top: 200px;
    padding-left: 30px;
}
.register_contentArea__D2BtU h1 {
    font-weight: 700;
    color: #fff;
    font-size: 4em;
}
.register_contentArea__D2BtU p {
    font-weight: 500;
    color: #fff;
}
.register_formArea__OPOFu {
    float: right;
    width: 65%;
    background: #fff;
}
#register_formWrapper__wr2-H {
    margin-right: auto;
    margin-left: auto;
    width: 800px;
    padding: 20px;
    margin-top: 120px;
}
#register_formWrapper__wr2-H h1 {
    font-weight: 700;
}
#register_formWrapper__wr2-H p {
    font-size: 16px;
    color: #666;
}
#register_formWrapper__wr2-H a {
    color: #0076ff;
    font-weight: 600;
    text-decoration: none;
}
.register_flexContainer__vYzof {
    display: flex;
    gap: 20px;
    margin-top: 20px;
    margin-bottom: 40px;
}
.register_flexContainer__vYzof span {
    font-size: 14px;
    font-weight: 500;
}
.register_flexContainer__vYzof input,select {
    width: 100%;
    padding: 10px;
    border-radius: 8px;
    border: 1px solid #ccc;
    border-bottom: 4px solid #ccc;
    outline: none;
    margin-top: 5px;
    display: block;
    transition: all ease 300ms;
}
.register_flexContainer__vYzof input:focus {
    border-bottom: 4px solid #0076ff;
}
.register_flexContainer__vYzof button {
    background: #0076ff;
    width: 100%;
    padding: 10px;
    border: 1px solid #0076ff;
    border-radius: 10px;
    color: #fff;
    font-weight: 700;
    border-bottom: 3px solid #0d478a;
    transition: all ease 300ms;
    cursor: pointer;
}
.register_flexContainer__vYzof button:hover {
    background: #0076ff;
    border: 1px solid #0076ff;
    border-bottom: 3px solid #0076ff;
}

.register_logo__8yp-w{
    width: 9em;
    border-radius: 50%;
    margin: auto 8em;
}`, "",{"version":3,"sources":["webpack://./src/core/css/register.module.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,eAAe;IACf,aAAa;IACb,sEAAsE;IACtE,UAAU;AACd;AACA;IACI,sBAAsB;AAC1B,6EAA6E;AAC7E,WAAW;AACX,YAAY;AACZ;AACA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;AACA;IACI,gBAAgB;IAChB,WAAW;IACX,cAAc;AAClB;AACA;IACI,gBAAgB;IAChB,WAAW;AACf;AACA;IACI,YAAY;IACZ,UAAU;IACV,gBAAgB;AACpB;AACA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,YAAY;IACZ,aAAa;IACb,iBAAiB;AACrB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,WAAW;AACf;AACA;IACI,cAAc;IACd,gBAAgB;IAChB,qBAAqB;AACzB;AACA;IACI,aAAa;IACb,SAAS;IACT,gBAAgB;IAChB,mBAAmB;AACvB;AACA;IACI,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,aAAa;IACb,kBAAkB;IAClB,sBAAsB;IACtB,6BAA6B;IAC7B,aAAa;IACb,eAAe;IACf,cAAc;IACd,0BAA0B;AAC9B;AACA;IACI,gCAAgC;AACpC;AACA;IACI,mBAAmB;IACnB,WAAW;IACX,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,gCAAgC;IAChC,0BAA0B;IAC1B,eAAe;AACnB;AACA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,gCAAgC;AACpC;;AAEA;IACI,UAAU;IACV,kBAAkB;IAClB,gBAAgB;AACpB","sourcesContent":[".imageArea {\n    float: left;\n    position: fixed;\n    height: 100vh;\n    background: url(https://source.unsplash.com/random/1920x1080/?finance);\n    width: 35%;\n}\n.imageArea .imageAreaOverlay {\n    background: rgb(0,0,0);\nbackground: linear-gradient(180deg, rgba(0,0,0,0.5) 0%, rgba(0,0,0,0.5) 100%);\nwidth: 100%;\nheight: 100%;\n}\n.contentArea {\n    margin-top: 200px;\n    padding-left: 30px;\n}\n.contentArea h1 {\n    font-weight: 700;\n    color: #fff;\n    font-size: 4em;\n}\n.contentArea p {\n    font-weight: 500;\n    color: #fff;\n}\n.formArea {\n    float: right;\n    width: 65%;\n    background: #fff;\n}\n#formWrapper {\n    margin-right: auto;\n    margin-left: auto;\n    width: 800px;\n    padding: 20px;\n    margin-top: 120px;\n}\n#formWrapper h1 {\n    font-weight: 700;\n}\n#formWrapper p {\n    font-size: 16px;\n    color: #666;\n}\n#formWrapper a {\n    color: #0076ff;\n    font-weight: 600;\n    text-decoration: none;\n}\n.flexContainer {\n    display: flex;\n    gap: 20px;\n    margin-top: 20px;\n    margin-bottom: 40px;\n}\n.flexContainer span {\n    font-size: 14px;\n    font-weight: 500;\n}\n.flexContainer input,select {\n    width: 100%;\n    padding: 10px;\n    border-radius: 8px;\n    border: 1px solid #ccc;\n    border-bottom: 4px solid #ccc;\n    outline: none;\n    margin-top: 5px;\n    display: block;\n    transition: all ease 300ms;\n}\n.flexContainer input:focus {\n    border-bottom: 4px solid #0076ff;\n}\n.flexContainer button {\n    background: #0076ff;\n    width: 100%;\n    padding: 10px;\n    border: 1px solid #0076ff;\n    border-radius: 10px;\n    color: #fff;\n    font-weight: 700;\n    border-bottom: 3px solid #0d478a;\n    transition: all ease 300ms;\n    cursor: pointer;\n}\n.flexContainer button:hover {\n    background: #0076ff;\n    border: 1px solid #0076ff;\n    border-bottom: 3px solid #0076ff;\n}\n\n.logo{\n    width: 9em;\n    border-radius: 50%;\n    margin: auto 8em;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"imageArea": `register_imageArea__Y0PNs`,
	"imageAreaOverlay": `register_imageAreaOverlay__zpJFT`,
	"contentArea": `register_contentArea__D2BtU`,
	"formArea": `register_formArea__OPOFu`,
	"formWrapper": `register_formWrapper__wr2-H`,
	"flexContainer": `register_flexContainer__vYzof`,
	"logo": `register_logo__8yp-w`
};
export default ___CSS_LOADER_EXPORT___;
